(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    function vigilstreetGetRealValue(input) {
    if (!input) return '';

    return (
      input.getAttribute('data-vigilstreet-real-value') ||
      input.value ||
      ''
    ).toLowerCase();
  }


  function vigilstreetGetProductMode(picker) {
    var productFieldset = picker.querySelector(
      '[data-vigilstreet-option="Product"]'
    );

    if (!productFieldset) return 'art';

    var selectedProduct = productFieldset.querySelector('input:checked');

    if (!selectedProduct) return 'art';

    var value = vigilstreetGetRealValue(selectedProduct);

    if (value.indexOf('metal poster') !== -1) {
      return 'metal';
    }

    return 'art';
  }


  function vigilstreetApplyVisualMode(picker) {
    if (!picker || picker.dataset.vigilstreetGelato !== 'true') return;

    var mode = vigilstreetGetProductMode(picker);

    picker.classList.toggle(
      'vigilstreet-metal-selected',
      mode === 'metal'
    );


    picker.querySelectorAll(
      '.vigilstreet-option-button'
    ).forEach(function(button) {

      button.classList.toggle(
        'is-selected',
        button.dataset.vigilstreetProductMode === mode
      );

    });


    var sizeFieldset = picker.querySelector(
      '[data-vigilstreet-option="Size"]'
    );

    if (sizeFieldset) {

      sizeFieldset.querySelectorAll('input').forEach(function(input) {

        var label = input.closest(
          '.variant-option__button-label'
        );

        if (!label) return;

        var value = vigilstreetGetRealValue(input);

        var isMetalSize =
          value.indexOf('m 44') !== -1 ||
          value.indexOf('l 64') !== -1 ||
          value.indexOf('xl 88') !== -1;

        var shouldShow;

        if (mode === 'metal') {
          shouldShow = isMetalSize;
        } else {
          shouldShow = !isMetalSize;
        }

        label.classList.toggle(
          'vigilstreet-size-hidden',
          !shouldShow
        );

      });

    }
  }


  function vigilstreetFindProductInput(picker, mode, framed) {
    var productFieldset = picker.querySelector(
      '[data-vigilstreet-option="Product"]'
    );

    if (!productFieldset) return null;

    var result = null;

    productFieldset.querySelectorAll('input').forEach(function(input) {

      var value = vigilstreetGetRealValue(input);

      if (mode === 'metal') {

        if (value.indexOf('metal poster') !== -1) {
          result = input;
        }

        return;
      }


      var isWoodFramed =
        value.indexOf('wooden framed poster') !== -1;

      var isPlainArt =
        value.indexOf('classic matte paper poster') !== -1 &&
        !isWoodFramed;


      if (framed && isWoodFramed) {
        result = input;
      }

      if (!framed && isPlainArt) {
        result = input;
      }

    });

    return result;
  }


  function vigilstreetFindFrameInput(picker, wantsUnframed) {
    var frameFieldset =
      picker.querySelector('[data-vigilstreet-option="Style"]') ||
      picker.querySelector('[data-vigilstreet-option="Frame"]') ||
      picker.querySelector('[data-vigilstreet-option="FRAME"]');

    if (!frameFieldset) return null;

    var result = null;

    frameFieldset.querySelectorAll('input').forEach(function(input) {

      var value = vigilstreetGetRealValue(input);

      var isUnframed =
        value === '-' ||
        value.indexOf('unframed') !== -1;

      if (wantsUnframed && isUnframed) {
        result = input;
      }

    });

    return result;
  }


  function vigilstreetFindSizeInput(picker, mode) {
    var sizeFieldset = picker.querySelector(
      '[data-vigilstreet-option="Size"]'
    );

    if (!sizeFieldset) return null;

    var checked = sizeFieldset.querySelector('input:checked');

    if (checked) {

      var checkedValue = vigilstreetGetRealValue(checked);

      var checkedIsMetal =
        checkedValue.indexOf('m 44') !== -1 ||
        checkedValue.indexOf('l 64') !== -1 ||
        checkedValue.indexOf('xl 88') !== -1;

      if (
        (mode === 'metal' && checkedIsMetal) ||
        (mode === 'art' && !checkedIsMetal)
      ) {
        return checked;
      }

    }


    var result = null;

    sizeFieldset.querySelectorAll('input').forEach(function(input) {

      if (result) return;

      var value = vigilstreetGetRealValue(input);

      var isMetal =
        value.indexOf('m 44') !== -1 ||
        value.indexOf('l 64') !== -1 ||
        value.indexOf('xl 88') !== -1;

      if (mode === 'metal' && isMetal) {
        result = input;
      }

      if (mode === 'art' && !isMetal) {
        result = input;
      }

    });

    return result;
  }


  function vigilstreetSetMode(picker, mode) {
    if (!picker || picker.dataset.vigilstreetGelato !== 'true') return;

    if (
      mode === 'metal' &&
      picker.dataset.vigilstreetHasMetal !== 'true'
    ) {
      return;
    }


    if (mode === 'metal') {

      var unframedInput = vigilstreetFindFrameInput(
        picker,
        true
      );

      if (
        unframedInput &&
        !unframedInput.checked
      ) {
        unframedInput.click();
        return;
      }


      var metalProduct = vigilstreetFindProductInput(
        picker,
        'metal',
        false
      );

      if (
        metalProduct &&
        !metalProduct.checked
      ) {
        metalProduct.click();
        return;
      }


      var metalSize = vigilstreetFindSizeInput(
        picker,
        'metal'
      );

      if (
        metalSize &&
        !metalSize.checked
      ) {
        metalSize.click();
        return;
      }


      vigilstreetApplyVisualMode(picker);
      return;
    }


    var currentFrameFieldset =
      picker.querySelector('[data-vigilstreet-option="Style"]') ||
      picker.querySelector('[data-vigilstreet-option="Frame"]') ||
      picker.querySelector('[data-vigilstreet-option="FRAME"]');

    var currentFrame =
      currentFrameFieldset
        ? currentFrameFieldset.querySelector('input:checked')
        : null;

    var currentFrameValue =
      vigilstreetGetRealValue(currentFrame);

    var wantsFramed =
      currentFrameValue !== '' &&
      currentFrameValue !== '-' &&
      currentFrameValue.indexOf('unframed') === -1;


    var artProduct = vigilstreetFindProductInput(
      picker,
      'art',
      wantsFramed
    );

    if (
      artProduct &&
      !artProduct.checked
    ) {
      artProduct.click();
      return;
    }


    var artSize = vigilstreetFindSizeInput(
      picker,
      'art'
    );

    if (
      artSize &&
      !artSize.checked
    ) {
      artSize.click();
      return;
    }


    vigilstreetApplyVisualMode(picker);
  }


  function vigilstreetSyncGelatoFrame(picker) {
    if (!picker || picker.dataset.vigilstreetGelato !== 'true') return;

    if (vigilstreetGetProductMode(picker) === 'metal') {
      return;
    }


    var frameFieldset =
      picker.querySelector('[data-vigilstreet-option="Style"]') ||
      picker.querySelector('[data-vigilstreet-option="Frame"]') ||
      picker.querySelector('[data-vigilstreet-option="FRAME"]');

    if (!frameFieldset) return;


    var frameInput = frameFieldset.querySelector('input:checked');

    if (!frameInput) return;


    var frameValue = vigilstreetGetRealValue(frameInput);

    var wantsUnframed =
      frameValue === '-' ||
      frameValue.indexOf('unframed') !== -1;


    var targetProduct = vigilstreetFindProductInput(
      picker,
      'art',
      !wantsUnframed
    );


    if (
      targetProduct &&
      !targetProduct.checked
    ) {
      targetProduct.click();
      return;
    }


    vigilstreetApplyVisualMode(picker);
  }


  document.addEventListener('click', function(event) {

    var button = event.target.closest(
      '.vigilstreet-option-button'
    );

    if (!button) return;


    var picker = button.closest('variant-picker');

    if (!picker) return;


    event.preventDefault();


    vigilstreetSetMode(
      picker,
      button.dataset.vigilstreetProductMode
    );

  });


  document.addEventListener('change', function(event) {

    var picker = event.target.closest('variant-picker');

    if (
      !picker ||
      picker.dataset.vigilstreetGelato !== 'true'
    ) {
      return;
    }


    var fieldset = event.target.closest(
      '[data-vigilstreet-option]'
    );

    if (!fieldset) return;


    var optionName = fieldset.getAttribute(
      'data-vigilstreet-option'
    );


    if (
      optionName === 'Style' ||
      optionName === 'Frame' ||
      optionName === 'FRAME'
    ) {

      setTimeout(function() {

        var currentPicker = document.querySelector(
          'variant-picker[data-product-id="' +
          picker.dataset.productId +
          '"]'
        );

        if (currentPicker) {
          vigilstreetSyncGelatoFrame(currentPicker);
        }

      }, 50);

      return;
    }


    setTimeout(function() {

      var currentPicker = document.querySelector(
        'variant-picker[data-product-id="' +
        picker.dataset.productId +
        '"]'
      );

      if (currentPicker) {
        vigilstreetApplyVisualMode(currentPicker);
      }

    }, 50);

  });


  function vigilstreetInitialisePickers() {

    document.querySelectorAll(
      'variant-picker[data-vigilstreet-gelato="true"]'
    ).forEach(function(picker) {

      vigilstreetApplyVisualMode(picker);

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      vigilstreetInitialisePickers
    );

  } else {

    vigilstreetInitialisePickers();

  }


  var vigilstreetObserver = new MutationObserver(function() {

    document.querySelectorAll(
      'variant-picker[data-vigilstreet-gelato="true"]'
    ).forEach(function(picker) {

      vigilstreetApplyVisualMode(picker);

    });

  });


  vigilstreetObserver.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
  } catch(e) { console.error(e); }
})();

})();
